import { render, staticRenderFns } from "./ValidateAccount.vue?vue&type=template&id=0129ef14"
import script from "./ValidateAccount.vue?vue&type=script&lang=js"
export * from "./ValidateAccount.vue?vue&type=script&lang=js"
import style0 from "./ValidateAccount.vue?vue&type=style&index=0&id=0129ef14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports